import { cn } from '@repo/lib/cn';
import { useMemo } from 'react';

import { useMeetingListContext } from '@/components/features/calendar';
import MeetingCard from '@/components/features/meeting/MeetingCard';
import MeetingCardSkeleton from '@/components/features/meeting/MeetingCardSkeleton';
import { EmptyState, EmptyStateContent, EmptyStateDescription } from '@/components/ui/empty-state';
import { InfiniteScroll } from '@/components/ui/infinite-scroll';

interface MeetingsListContentProps {
  className?: string;
}

export default function MeetingsListContent(props: MeetingsListContentProps) {
  const { className } = props;

  const { meetings, fetchNextPage, isLoading, isSuccess, isFetching, hasNextPage } = useMeetingListContext();

  const meetingsIsEmpty = useMemo(() => meetings.length === 0 && !isFetching, [meetings, isFetching]);

  const next = () => {
    if (fetchNextPage) {
      fetchNextPage();
    }
  };

  return (
    <div className={cn('flex grow flex-col gap-2 overflow-hidden overflow-y-auto overscroll-contain p-4', className)}>
      {meetings.map((meeting) => (
        <MeetingCard key={meeting.id} meeting={meeting} />
      ))}

      {isLoading && (
        <>
          <MeetingCardSkeleton />
          <MeetingCardSkeleton />
        </>
      )}
      {hasNextPage !== undefined ? (
        <InfiniteScroll hasNextPage={hasNextPage} isLoading={isFetching} isFetching={isFetching} next={next} threshold={0.65} root={null}>
          {hasNextPage && <MeetingCardSkeleton />}
        </InfiniteScroll>
      ) : null}

      {isSuccess && meetingsIsEmpty ? (
        <EmptyState>
          <EmptyStateContent>
            <EmptyStateDescription>Brak spotkań</EmptyStateDescription>
          </EmptyStateContent>
        </EmptyState>
      ) : null}
    </div>
  );
}
